import React from "react"
import { Alert, Button, Col, Row, Space, Typography } from "antd"
import { SaveOutlined } from "@ant-design/icons"
import { textNumberFormater } from "../../../../utils"

const { Text } = Typography

interface NoteSummaryFooterProps {
  financialImpactMessage: string
  totals: {
    total_amount: number
    total_discount_amount: number
    total_tax_amount: number
    total_amount_net: number
  }
  submitting: boolean
  disabled: boolean
  isMobile?: boolean
}

export const NoteSummaryFooter: React.FC<NoteSummaryFooterProps> = ({
  financialImpactMessage,
  totals,
  submitting,
  disabled,
  isMobile
}) => {
  return (
    <div
      style={{
        position: "sticky",
        bottom: 0,
        background: "#fff",
        padding: isMobile ? "12px 14px" : "14px 18px",
        boxShadow: "0 -4px 12px rgba(0,0,0,0.08)",
        zIndex: 10,
        borderRadius: "8px",
        marginTop: "16px",
        border: "1px solid #f0f0f0",
      }}
    >
      <Row gutter={[14, 10]} align="middle" justify="space-between">
        <Col xs={24} lg={12}>
          <Alert 
            message={financialImpactMessage} 
            type="info" 
            showIcon 
            style={{ textAlign: "left", margin: 0 }}
          />
        </Col>
        <Col xs={24} lg={12}>
          <Space direction="vertical" size={3} style={{ width: "100%", textAlign: "right" }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
              <Text type="secondary">Subtotal:</Text>
              <Text>{textNumberFormater(totals.total_amount)}</Text>
            </div>
            {totals.total_discount_amount > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <Text type="secondary">Descuentos:</Text>
                <Text>{textNumberFormater(totals.total_discount_amount)}</Text>
              </div>
            )}
            {totals.total_tax_amount > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <Text type="secondary">Impuestos:</Text>
                <Text>{textNumberFormater(totals.total_tax_amount)}</Text>
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16, alignItems: "baseline", borderTop: "1px solid #f0f0f0", paddingTop: 4 }}>
              <Text strong style={{ fontSize: 15 }}>Total Nota:</Text>
              <Text strong style={{ fontSize: 20, color: '#1890ff' }}>{textNumberFormater(totals.total_amount_net)}</Text>
            </div>
            <div style={{ marginTop: 8 }}>
              <Button 
                type="primary" 
                size="large" 
                icon={<SaveOutlined />} 
                htmlType="submit" 
                loading={submitting}
                disabled={disabled}
                block={isMobile}
                style={{ minWidth: isMobile ? undefined : 160 }}
              >
                Generar Nota
              </Button>
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  )
}
